import React from "react";
import { Box, Skeleton, Stack, Typography } from "@mui/material";

// Matches the number of stages rendered by DatacollectionLastRunValueFlow
const FLOW_STEPS = 7;

/**
 * Placeholder for the parts of the Deep View drawer header that come from the
 * API — brand name, context chips and the value flow. The metric label and
 * value above them are known from the clicked cell, so they are never skeletons.
 */
const DeepViewHeaderSkeleton = () => (
  <>
    <Skeleton variant="text" width={180} sx={{ fontSize: "12px" }} />

    <Stack direction="row" spacing={1} mt={0.5}>
      {[190, 180, 120].map((width) => (
        <Skeleton
          key={width}
          variant="rounded"
          width={width}
          height={20}
          sx={{ borderRadius: "5px" }}
        />
      ))}
    </Stack>

    <Box
      sx={{
        border: "1px solid #BDBDBD",
        borderRadius: "5px",
        backgroundColor: "#FAFAFA",
        p: 1,
        overflowX: "hidden",
        width: "100%",
        mt: 1,
        height: 100,
      }}
    >
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 500,
          color: "#00000099",
          letterSpacing: "0.46px",
          mb: 0.5,
        }}
      >
        VALUE FLOW - HOW WE GOT THIS NUMBER
      </Typography>

      <Stack direction="row" alignItems="center" justifyContent="flex-start">
        {Array.from({ length: FLOW_STEPS }).map((_, index) => (
          <React.Fragment key={index}>
            <Box sx={{ pr: 2 }}>
              <Skeleton variant="text" width={56} sx={{ fontSize: 10 }} />
              <Skeleton variant="text" width={36} sx={{ fontSize: 12 }} />
              <Skeleton variant="text" width={46} sx={{ fontSize: 8 }} />
            </Box>
            {index < FLOW_STEPS - 1 && (
              <Skeleton variant="text" width={12} sx={{ mx: 1 }} />
            )}
          </React.Fragment>
        ))}
      </Stack>
    </Box>
  </>
);

export default DeepViewHeaderSkeleton;
